import React from "react";
import styles from "../../../../BorrowerDetails.module.css";
import { useState, useEffect } from "react";
import BRE from "./Components/BRE/BRE";
import Bureau from "./Components/Bureau/Bureau";
import Computation from "./Components/Computation/Computation";
import Income from "./Components/Income/Income";
import Obligations from "./Components/Obligations/Obligations";
import SecondaryIncome from "./Components/SecondaryIncome/SecondaryIncome";
import Expenses from "./Components/Expenses/Expenses";
import Deviation from "./Components/Deviation/Deviation";
import Cookies from 'js-cookie';
import axios from "axios";
import { url } from "../../../../../../../App";

const Cam = ({ openLoader, closeLoader }) => {
  const [showDiv, setshowDiv] = useState("");
  const EMAIL = Cookies.get('Email');
  const TOKEN = Cookies.get('Token');
  const [visible, setvisible] = useState(false);
  const [sections, setSections] = useState({
    primaryIncome: false,
    secondaryIncome: false,
    expenses: false,
    obligations: false,
    bureau: false,
    computation: false,
    bre: false,
    deviation: false
  });

  const handleDiv = (e, val) => {
    setshowDiv(val);
  };

  useEffect(() => {
    if (EMAIL === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: TOKEN,
          email: EMAIL,
          useremail: EMAIL
        })
        .then((res) => {
          const perm = res.data[0]?.permission || {};
          setSections({
            primaryIncome: perm.primary_cam,
            secondaryIncome: perm.secondary_cam,
            expenses: perm.expenses_cam,
            obligations: perm.obligations_cam,
            bureau: perm.bureau_cam,
            computation: perm.computation_cam,
            bre: perm.bre_cam,
            deviation: perm.deviation_cam
          });
        })
        .catch((err) => {
          console.log(err);
        })
    };

  }, [EMAIL, TOKEN]);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {(sections.primaryIncome || visible) && (
          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "Primary Income")}
            style={{
              backgroundColor: showDiv === "Primary Income" ? "#034ea1" : "#eef7ff",
              color: showDiv === "Primary Income" ? "white" : "gray",
            }}
          >
            Primary Income
          </button>
        )}
        {(sections.secondaryIncome || visible) && (

          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "Secondary Income")}
            style={{
              backgroundColor: showDiv === "Secondary Income" ? "#034ea1" : "#eef7ff",
              color: showDiv === "Secondary Income" ? "white" : "gray",
            }}
          >
            Secondary Income
          </button>
        )}

        {(sections.expenses || visible) && (

          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "Expenses")}
            style={{
              backgroundColor: showDiv === "Expenses" ? "#034ea1" : "#eef7ff",
              color: showDiv === "Expenses" ? "white" : "gray",
            }}
          >
            Expenses
          </button>
        )}
        {(sections.obligations || visible) && (

          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "Obligations")}
            style={{
              backgroundColor: showDiv === "Obligations" ? "#034ea1" : "#eef7ff",
              color: showDiv === "Obligations" ? "white" : "gray",
            }}
          >
            Obligations
          </button>
        )}
        {(sections.bureau || visible) && (

          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "Bureau")}
            style={{
              backgroundColor: showDiv === "Bureau" ? "#034ea1" : "#eef7ff",
              color: showDiv === "Bureau" ? "white" : "gray",
            }}
          >
            Bureau
          </button>
        )}
        {(sections.computation || visible) && (

          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "Computation")}
            style={{
              backgroundColor: showDiv === "Computation" ? "#034ea1" : "#eef7ff",
              color: showDiv === "Computation" ? "white" : "gray",
            }}
          >
            Computation
          </button>
        )}
        {(sections.bre || visible) && (

          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "BRE")}
            style={{
              backgroundColor: showDiv === "BRE" ? "#034ea1" : "#eef7ff",
              color: showDiv === "BRE" ? "white" : "gray",
            }}
          >
            BRE
          </button>
        )}
        {(sections.deviation || visible) && (

          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "Deviation")}
            style={{
              backgroundColor: showDiv === "Deviation" ? "#034ea1" : "#eef7ff",
              color: showDiv === "Deviation" ? "white" : "gray",
            }}
          >
            Deviation
          </button>
        )}
      </div>

      {showDiv === "BRE" && (
        <div>
          <BRE
            // cpvUpload={cpvUpload}
            openLoader={openLoader}
            closeloader={closeLoader}
          />
        </div>
      )}
      {showDiv === "Bureau" && (
        <div>
          <Bureau openLoader={openLoader} closeLoader={closeLoader} />
        </div>
      )}
      {showDiv === "Computation" && (
        <div>
          <Computation />
        </div>
      )}
      {showDiv === "Primary Income" && (
        <div>
          <Income />
        </div>
      )}
      {showDiv === "Secondary Income" && (
        <div>
          <SecondaryIncome />
        </div>
      )}
      {showDiv === "Expenses" && (
        <div>
          <Expenses />
        </div>
      )}
      {showDiv === "Obligations" && (
        <div>
          <Obligations />
        </div>
      )}
      {showDiv === "Deviation" && (
        <div>
          <Deviation />
        </div>
      )}
    </>
  );
};

export default Cam;
